<template>
  <div style="padding-top: -2px; margin-top: -2px">
    <v-label
      ><b>{{ label }}</b></v-label
    >
    <s-select-generic
      autocomplete
      :autofocus="autofocus"
      class="text"
      itemvalue="FrcID"
      :disabled="disabled"
      :value="value"
      id="FrcID"
      itemtext="FullName"
      :return-object="returnObject"
      @input="input($event)"
      :config="config"
      :full="full"
      :text="text"
      :clearable="clearable"
      :noDefault="noDefault"
      @onClearClicked="onClearClicked()"
      @change="changeResponsible($event)"
    >
    </s-select-generic>
  </div>
</template>

<script>
import _sService from "@/services/Technicalassistance/TasProducerContractService.js";
export default {
  name: "sSelectResponsibleCollectingFarmLot",
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    value: null,
    text: { type: String, default: "" },
    label: {
      type: String,
      default: "",
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    noDefault: {
      type: Boolean,
      default: false,
    },
    full: {
      type: Boolean,
      default: true,
    },
    FltID: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    text() {},
    value(value) {
      this.item = value;
    },
    FltID() {
      console.log("cambio de FltID ", this.FltID);
      // Para que Vue/sSelectGeneric detecte el cambio de 'config',
      // tenemos que reemplazar todo el objeto en lugar de solo mutar inner params.
      this.config = Object.assign({}, this.config, {
        params: {
          ...this.config.params,
          FltID: this.FltID || 0,
        },
      });
    },
  },
  methods: {
    changeResponsible(data) {
      if (this.item > 0) {
        var resp = data.filter((x) => x.FrcID == this.item);
        this.$emit("changeResp", resp[0]);
      }
    },
    onClearClicked() {
      this.$emit("onClearClicked");
    },
    input(val) {
      this.$emit("input", val);
    },
  },
  data: () => ({
    item: 0,
    val: "",
    items: [],
    config: {},
  }),

  created() {
    console.log(
      "⭐ [sSelectResponsibleCollectingFarmLot] created()! Prop FltID recibe:",
      this.FltID,
    );
    this.config = {
      url: _sService.getUrlResponsibleCollectingFarmLot(),
      title: this.label,
      params: {
        FltID: this.FltID || 0,
        search: "",
        requestID: this.$fun.getUserID(),
      },
    };
  },
};
</script>

<style scoped></style>
